

//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_SUB_TIPO_SOCIOS = "obtenerSubTipoSocios";
export const OBTENER_SUB_TIPO_SOCIO = "obtenerSubTipoSocio";
// mutation types
export const SET_SUB_TIPO_SOCIOS = "setSubTipoSocios";
export const SET_SUB_TIPO_SOCIO = "setSubTipoSocio";

const state = {
    subTipoSocios: [],
    subTipoSocio:[],
}

const getters = {
    obtenerSubTipoSocios(state) {
      return state.subTipoSocios;
    },
}

const actions = {
    async [OBTENER_SUB_TIPO_SOCIOS](context, data) {

       
        /*
        * Si el estado es null va a traer a todas las etnias, de lo contrario va a traer los etnias por estado
        *
        */
        let endpoint = 'api/SubTipo_Socios'
        if(data.estadoId){
            endpoint = `api/SubTipo_Socios/GetSubTiposSocioByTipoSocioActivos/${data.estadoId}/${data.tipoSocioId}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_SUB_TIPO_SOCIOS, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },

    

    async [OBTENER_SUB_TIPO_SOCIO](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Empresas/`)
                .then(({ data }) => {
                    context.commit(SET_SUB_TIPO_SOCIO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    }
  }

const mutations = {
    [SET_SUB_TIPO_SOCIOS](state, data) {
        state.subTipoSocios = data;
    },

    [SET_SUB_TIPO_SOCIO](state, data) {
        state.subTipoSocio = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}